import { defineComponent as u, useTemplateRef as c, ref as d, computed as r, provide as v, watch as y, createElementBlock as B, openBlock as w, mergeProps as x, unref as t, createVNode as _, withCtx as $, renderSlot as P } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Drawer/drawer.js";
import C from "../../helpers/AutoWrap.vue2.js";
import { DrawerKey as D } from "./common.js";
import I from "./DrawerContent.vue2.js";
import R from "./DrawerSection.vue2.js";
import { useOUIAProps as S } from "../../helpers/ouia.js";
const K = /* @__PURE__ */ u({
  name: "PfDrawer",
  __name: "Drawer",
  props: {
    expanded: { type: Boolean },
    inline: { type: Boolean },
    static: { type: Boolean },
    position: { default: "end" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(l) {
    const e = l, m = S({ id: e.ouiaId, safe: e.ouiaSafe }), f = c("elRef"), n = d(e.static || e.expanded), a = d(e.expanded), s = r(() => e.static || e.expanded);
    return v(D, {
      el: f,
      expanded: s,
      display: n,
      inline: r(() => e.inline),
      position: r(() => e.position)
    }), y(s, (o) => {
      o ? (n.value = !0, setTimeout(() => a.value = !0, 50)) : a.value = !1;
    }), (o, p) => (w(), B("div", x(t(m), {
      ref: "elRef",
      class: [t(i).drawer, {
        [t(i).modifiers.expanded]: a.value,
        [t(i).modifiers.inline]: o.inline,
        [t(i).modifiers.static]: o.static,
        [t(i).modifiers.panelLeft]: o.position === "start",
        [t(i).modifiers.panelBottom]: o.position === "bottom"
      }],
      onAnimationend: p[0] || (p[0] = (k) => n.value = s.value)
    }), [
      _(C, {
        component: I,
        exclude: R
      }, {
        default: $(() => [
          P(o.$slots, "default")
        ]),
        _: 3
      })
    ], 16));
  }
});
export {
  K as default
};
